import AppImages from "../assets/appImages";
import { isNcdcMode } from "./Constant";

const theYear = new Date().getFullYear();
const appName = import.meta.env.VITE_APP_NAME || "eN-LIS";
const tagLine = "Electronic National Laboratory Information System (eN-LIS)";
const footerText = `${appName} © ${theYear}`;
const adminMail = "mailto:mdalhatu@gghnigeria.org?";
const adminMailNewAccount = `${adminMail}?subject=Request%20for%20Enlis%20Account&body=Hello%20Admin,%0A%0AI%20would%20like%20to%20request%20for%20an%20Enlis%20account.%0A%0AKind%20regards,%0A%0A%5BYour%20Name%5D%0A%5BYour%20Email%5D%0A%5BYour%20Phone%20Number%5D%0A%5BYour%20Organization%5D%0A%5BYour%20Position%5D%0A%5BFacility%20Name%5D%0A%5BFull%20Address%5D%0A%5BLGA%5D%0A%5BState%5D%0A%5BFacility%20Code%5D%0A%5BFacility%20Name%5D%0A%5BFacility%20Code%5D%0A%5BFacility%20State%5D%0A%5BLGA%5D%0A%5BAddress%5D%0A%5BType%5D%0A%5BPrefix%5D`;
const adminMailHelp = `${adminMail}subject=Help%20and%20Support&body=Hello%20Admin,%0A%0AI%20would%20like%20to%20request%20for%20help%20and%20support.%0A%0AKind%20regards,%0A%0A%5BYour%20Name%5D%0A%5BYour%20Email%5D%0A%5BYour%20Phone%20Number%5D%0A%5BYour%20Organization%5D%0A%5BYour%20Position%5D`;

const basePath = "/";

const AppConfig = {
  footerText,
  appName,
  tagLine,
  logo: isNcdcMode ? AppImages.NCDCLogo : AppImages.Logo,
  logoSm: isNcdcMode ? AppImages.NCDCLogo : AppImages.LogoSm,
  logInImage: AppImages.LoginImage,
  spiral: AppImages.SpiralImage,
  adminMailNewAccount,
  adminMailHelp,
  basePath,
};

/**
 * ENLIS Configuration
 * Single source of truth for all application constants and utilities
 */

// ===================
// TEST STATUS CODES
// ===================
export const TEST_STATUS = {
  SAMPLE: {
    ORDERED: 1,
    COLLECTED: 2,
    APPROVED: 3,
    REJECTED: 4,
    RECEIVED: 10,
    ONGOING: 11,
    WORKSHEET: 12,
    DISPATCHED: 13,
    PARTIAL_REJECTED: 14,
    ON_HOLD: 15,
    RE_RUN: 16,
  },
  RESULT: {
    ENTERED: 5,
    VERIFIED: 6,
    APPROVAL: 7,
    REJECTED: 8,
    RETEST: 9,
  },
};

// ===================
// LAB IDENTIFIERS
// ===================
export const LAB_IDENTIFIERS = {
  HOSPITAL_NUMBER: 1,
  LGA_TB_NUMBER: 2,
  DR_REGISTER_NUMBER: 3,
  NATIONAL_IDENTIFICATION_NUMBER: 4,
  LAB_NUMBER: 5,
  EPID: 6,
};

// ===================
// NIPOST CONFIG
// ===================
export const NIPOST_CONFIG = {
  API_KEY: "CS24FTZYO6BMLAB5QVJG",
  USER_ID: "info@naca.gov.ng",
};

// ===================
// BACKWARD COMPATIBILITY EXPORTS
// ===================

// Sample Status (old variable names)
export const orderedStatus = TEST_STATUS.SAMPLE.ORDERED;
export const collectedStatus = TEST_STATUS.SAMPLE.COLLECTED;
export const approvedStatus = TEST_STATUS.SAMPLE.APPROVED;
export const rejectedStatus = TEST_STATUS.SAMPLE.REJECTED;
export const receivedStatus = TEST_STATUS.SAMPLE.RECEIVED;
export const reRunStatus = TEST_STATUS.SAMPLE.RE_RUN;
export const onGoingStatus = TEST_STATUS.SAMPLE.ONGOING;
export const workSheetStatus = TEST_STATUS.SAMPLE.WORKSHEET;
export const dispatchedStatus = TEST_STATUS.SAMPLE.DISPATCHED;
export const onHoldStatus = TEST_STATUS.SAMPLE.ON_HOLD;
export const partiallyRejectedStatus = TEST_STATUS.SAMPLE.PARTIAL_REJECTED;

// Result Status (old variable names)
export const enteredStatus = TEST_STATUS.RESULT.ENTERED;
export const verifiedStatus = TEST_STATUS.RESULT.VERIFIED;
export const approvalStatus = TEST_STATUS.RESULT.APPROVAL;
export const resultRejectedStatus = TEST_STATUS.RESULT.REJECTED;
export const retestStatus = TEST_STATUS.RESULT.RETEST;

// Lab Identifiers (old variable names)
export const hospitalNumber = LAB_IDENTIFIERS.HOSPITAL_NUMBER;
export const lgaTBNumber = LAB_IDENTIFIERS.LGA_TB_NUMBER;
export const drRegNumber = LAB_IDENTIFIERS.DR_REGISTER_NUMBER;
export const NationalIDNumber = LAB_IDENTIFIERS.NATIONAL_IDENTIFICATION_NUMBER;
export const labNumber = LAB_IDENTIFIERS.LAB_NUMBER;
export const epidNumber = LAB_IDENTIFIERS.EPID;

// ===================
// HELPER FUNCTIONS
// ===================

export const getStatusName = (statusId) => {
  const statusMap = {
    [TEST_STATUS.SAMPLE.ORDERED]: "Ordered",
    [TEST_STATUS.SAMPLE.COLLECTED]: "Collected",
    [TEST_STATUS.SAMPLE.APPROVED]: "Approved",
    [TEST_STATUS.SAMPLE.REJECTED]: "Rejected",
    [TEST_STATUS.SAMPLE.RECEIVED]: "Received",
    [TEST_STATUS.SAMPLE.ONGOING]: "Ongoing",
    [TEST_STATUS.SAMPLE.WORKSHEET]: "Worksheet",
    [TEST_STATUS.SAMPLE.DISPATCHED]: "Dispatched",
    [TEST_STATUS.SAMPLE.ON_HOLD]: "On Hold",
    [TEST_STATUS.SAMPLE.PARTIAL_REJECTED]: "Partially Rejected",
    [TEST_STATUS.RESULT.ENTERED]: "Result Entered",
    [TEST_STATUS.RESULT.VERIFIED]: "Result Verified",
    [TEST_STATUS.RESULT.APPROVAL]: "Result Approved",
    [TEST_STATUS.RESULT.REJECTED]: "Result Rejected",
    [TEST_STATUS.RESULT.RETEST]: "Retest Required",
  };
  return statusMap[statusId] || "Unknown Status";
};

export const isSampleStatus = (statusId) =>
  Object.values(TEST_STATUS.SAMPLE).includes(statusId);
export const isResultStatus = (statusId) =>
  Object.values(TEST_STATUS.RESULT).includes(statusId);

export default AppConfig;
